export const TENANTS_ENDPOINTS = {
    LIST: `/tenants`,
    CREATE: `/tenants`,
    GET_BY_ID: (id: string) => `/tenants/${id}`,
    UPDATE_BY_ID: (id: string) => `/tenants/${id}`,
    WHATSAPP_ONBOARDING: (id: string) => `/tenants/${id}/onboarding/whatsapp`,
    FACEBOOK_ONBOARDING: (id: string) => `/tenants/${id}/onboarding/facebook`,
    GET_AGENTS: (id: string) => `/tenants/${id}/agents`,
    // Main agents endpoint (with proper IDs)
    LIST_AGENTS: `/agents`,
    // Settings endpoints
    GET_THIRD_PARTY_SETTINGS: `/settings/third-party`,
    UPDATE_THIRD_PARTY_SETTINGS: `/settings/third-party`,
    // WhatsApp Template endpoints
    LIST_WHATSAPP_TEMPLATES: `/templates/whatsapp/templates`,
    CREATE_WHATSAPP_TEMPLATE: `/templates/whatsapp/templates`,
    GET_WHATSAPP_TEMPLATE: (id: number) => `/templates/whatsapp/templates/${id}`,
    DELETE_WHATSAPP_TEMPLATE: (id: number) => `/templates/whatsapp/templates/${id}`,
} as const; 